const TrucksTableNoResultsContent: React.FC = () =>
  <div className="text-center flex flex-col gap-1 py-4">
    <span className="text-sm text-theme-text">No loads during selected hour.</span>
    <div className="h-[2px] w-[15rem] bg-theme-table-border" />
  </div>

export default TrucksTableNoResultsContent;